import { BASE_URL, deleteRequest, post } from "./Common";

export const RemoveUserFromRoom = (l1Id: number, userId: string, authToken: string) => {
  const url = `${BASE_URL}/roommate/${l1Id}/user/${userId}`;

  return deleteRequest(url, authToken);
};

export const LockUserInRoom = (l1Id: number, l2Id: number, l3Id: number, targets: string[], authToken: string) => {
  const url = `${BASE_URL}/roommate/${l1Id}/subnetwork/${l2Id}/unit_type/${l3Id}/lock`;

  return post(url, authToken, undefined, { targets });
};

export const LockAllUsersInRoom = (l1Id: number, l2Id: number, l3Id: number, authToken: string) => {
  const url = `${BASE_URL}/roommate/${l1Id}/subnetwork/${l2Id}/unit_type/${l3Id}/lock_all`;

  return post(url, authToken, undefined);
};

export const UnlockUserInRoom = (l1Id: number, l2Id: number, l3Id: number, targets: string[], authToken: string) => {
  const url = `${BASE_URL}/roommate/${l1Id}/subnetwork/${l2Id}/unit_type/${l3Id}/lock`;

  return deleteRequest(url, authToken, undefined, { targets });
};

export const UnlockAllUsersInRoom = (l1Id: number, l2Id: number, l3Id: number, authToken: string) => {
  const url = `${BASE_URL}/roommate/${l1Id}/subnetwork/${l2Id}/unit_type/${l3Id}/lock_all`;

  return deleteRequest(url, authToken, undefined);
};


interface ISharingBadroomBody {
  roommate: string;
  targetRoommate: string | null;
}

export const DeleteSharingBadroom = (
  l1Id: number,
  l2Id: number,
  l3Id: number,
  body: ISharingBadroomBody,
  authToken: string
) => {
  const url = `${BASE_URL}/roommate/${l1Id}/subnetwork/${l2Id}/unit_type/${l3Id}/same_room`;

  return deleteRequest(url, authToken, undefined, body);
};

export const PostSharingBadroom = (
  l1Id: number,
  l2Id: number,
  l3Id: number,
  body: ISharingBadroomBody,
  authToken: string
) => {
  const url = `${BASE_URL}/roommate/${l1Id}/subnetwork/${l2Id}/unit_type/${l3Id}/same_room`;

  return post(url, authToken, undefined, body);
};
